import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { FeedbackType, IState } from './types'

const state: IState = {
  message: '',
  feedbackType: FeedbackType.NO_FEEDBACK,
  isVisible: false,
  time: undefined,
}

export default {
  state,
  actions,
  getters,
  mutations,
}
